module.exports = __webpack_public_path__ + "img/logoLawFirm.987a72b5.png";